import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

function Notifications(props) {
    return (
        <div className="withCount right cursorPointer" id="HeaderNotifications" title={gettext('Notifications')}>
            <img src={`${props.staticUrl}img/NotificationIcon_20px.png`} alt="notifications" />
            <span className="count roundBorder6 dropShadowDark dijitHidden">0</span>
        </div>
    );
}

Notifications.propTypes = {
    staticUrl: PropTypes.string.isRequired
};

const mapStateToProps = state => ({ staticUrl: state.getIn(['site', 'staticUrl']) });

export default connect(mapStateToProps)(Notifications);



// WEBPACK FOOTER //
// ./source/containers/SiteHeaderBar/Notifications.jsx